import request from './request';

export default {
  getList: ({ locationId }) => request.easytip({
    method: 'get',
    url: `/v5/workplaces/${locationId}/checkin-managers`,
  }),
  create: ({ locationId, ...data }) => request.easytip({
    method: 'post',
    url: `/v5/workplaces/${locationId}/checkin-managers/registration`,
    data,
  }),
  deactivate: ({ locationId, id }) => request.easytip({
    method: 'delete',
    url: `/v5/workplaces/${locationId}/checkin-managers/${id}`,
  }),
};
